import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import nextScriptNameGenerator from '../../../../services/mini/nextScriptNameGenerator';
import { Loader } from '../../../components/Loader/Loader';
import * as actions from '../../../../redux/predefinedScripts/actions.predefinedScripts';
import withClickOutsideOnOverlay from '../../../../hoc/withClickOutsideOnOverlay';
import device from '../../../../services/mini/device';
import ValidationForm from '../../../forms/ValidationForm';
import PredefinedScriptItem from '../PredefinedScriptItem/PredefinedScriptItem';
import PredefinedScriptItemTile from '../PredefinedScriptItemTile/PredefinedScriptItemTile';
import PopupWrapper from '../../../components/Popup/PopupWrapper';
import PopupHeader from '../../../components/Popup/PopupHeader';
import { cancelButtonClass, okButtonClass } from '../../../../const/popupButtonClasses';
import { validateScriptName } from '../../../../services/validations/validateScriptName';
import projectHelper from '../../../../services/ProjectHelper';

class NewScriptForm extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            scriptName: '',
            selectedPredefinedScripts: []
        };
    }

    componentDidMount() {
        const { getPredefinedScripts, project } = this.props;
        getPredefinedScripts({ sluVersion: project.sluVersion });
    }

    validateScriptName = ({ scriptName }) => {
        const { project } = this.props;

        return validateScriptName(scriptName, project);
    }

    create = ({ scriptName }) => {
        const { project, createScript, onClose } = this.props;
        const { selectedPredefinedScripts } = this.state;
        const scripts = selectedPredefinedScripts.length > 0 ?
            selectedPredefinedScripts :
            [{ title: scriptName, body: '' }];

        createScript({
            projectId: project.projectId,
            tagId: project.stageTagId,
            scripts: scripts
        });
        onClose();
    }

    cancel = () => {
        this.props.onClose();
    }

    togglePredefinedScript = (title) => {
        let newScriptName = title.replace(/ /g, '');
        let { selectedPredefinedScripts } = this.state;
        const { predefinedScripts } = this.props;
        const { project } = this.props;
        const existingTemplateInd = _.findIndex(selectedPredefinedScripts, {
            initialTitle: title
        });

        const script = _.find(predefinedScripts, {
            title: title
        });

        newScriptName = nextScriptNameGenerator(newScriptName, project.scripts.map((script) => script.name));

        if (existingTemplateInd > -1) {
            selectedPredefinedScripts.splice(existingTemplateInd, 1);
        } else {
            selectedPredefinedScripts.push({
                ...script,
                title: newScriptName,
                initialTitle: title
            });
        }

        this.setState({
            selectedPredefinedScripts: _.sortBy(selectedPredefinedScripts, 'title')
        });
    }

    removeSelection = () => {
        this.setState({
            selectedPredefinedScripts: [],
        });
    }

    render() {
        const {
            predefinedScripts,
            project
        } = this.props;

        const {
            selectedPredefinedScripts,
            scriptName,
        } = this.state;

        const hidePredefinedScripts = projectHelper.isSlu4_1(project) || projectHelper.isSlu4_2(project);

        const predefinedScriptBtns = <div className="new-script-form_predefined-scripts_btns">
            <div onClick={this.create}
                className="action-btn width-100p">
                Add {selectedPredefinedScripts.length > 0 && selectedPredefinedScripts.length} Predefined Script{selectedPredefinedScripts.length > 1 && 's'}
            </div>
            <div className="action-btn width-100p cancel-action light-blue-with-border"
                onClick={this.removeSelection}>
                Remove Selection
            </div>
            <div className="action-btn width-100p cancel-action"
                onClick={this.cancel}>
                Cancel
            </div>
        </div>;

        const leftPartHeader = selectedPredefinedScripts.length === 0 ?
            'Create new script' :
            'Add script examples';

        const rightPartHeader = selectedPredefinedScripts.length === 0 ?
            'or Add script example' :
            '';



        const newScriptForm = <div className="new-script-form_add-script-form"><ValidationForm
            enableActionBtnByDefault={true}
            enableActionBtnAlways={true}
            btnsClassName={`new-script-form_btns ${hidePredefinedScripts && 'new-script-only popup-form_btns'}`}
            inputs={[
                {
                    label: "New script name",
                    name: "scriptName",
                    value: scriptName,
                    maxLength: 50,
                    maxLengthMsg: `Max script name length: 50 characters`,
                    applyOnEnter: true,
                    rules: [this.validateScriptName]
                }
            ]}
            buttons={[
                {
                    key: 'ok',
                    label: 'Add New Script',
                    action: this.create,
                    className: `${okButtonClass} ${!hidePredefinedScripts && 'width-100p new-script-form_create-script-btn'} `
                },
                {
                    key: 'cancel',
                    label: 'Cancel',
                    action: this.cancel,
                    className: `${cancelButtonClass} ${!hidePredefinedScripts && 'width-100p new-script-form_cancel-btn'} `
                }
            ]}
        /></div>;

        const desktopContent = <div className="new-script-form_content">
            <div className={`new-script-form_left-part ${hidePredefinedScripts && 'new-script-only'}`}>
                <div className="new-script-form_header">{leftPartHeader}</div>
                <div className={`new-script-form_left-part_body `}>
                    {selectedPredefinedScripts.length === 0 ?
                        newScriptForm :
                        <React.Fragment>
                            <div className="new-script-form_predefined-scripts_list">
                                {selectedPredefinedScripts.map(({ name, initialTitle }) => {
                                    return <PredefinedScriptItemTile
                                        key={name}
                                        name={name}
                                        title={initialTitle}
                                        unselectScript={this.togglePredefinedScript}
                                    />;
                                })}
                            </div>
                            {predefinedScriptBtns}
                        </React.Fragment>
                    }
                </div>

            </div>
            {!hidePredefinedScripts &&
                <div className="new-script-form_predefined-scripts">
                    <div className="new-script-form_header">
                        {rightPartHeader}
                    </div>
                    <div className="new-script-form_predefined-scripts_body">
                        {!predefinedScripts ?
                            <Loader theme="dark" size="big" center={true} /> :
                            predefinedScripts.map(({ name, title, description }) => {
                                const isSelected = !!_.find(selectedPredefinedScripts, { initialTitle: title });
                                return <PredefinedScriptItem
                                    key={name}
                                    name={name}
                                    title={title}
                                    description={description}
                                    isSelected={isSelected}
                                    toggleScriptTemplate={this.togglePredefinedScript}
                                />;
                            })}
                    </div>
                </div>}
        </div>;

        const mobileContent = <div className="new-script-form_content">
            <div className="new-script-form_predefined-scripts">
                <PopupHeader title="Add script example" onCancel={this.cancel} />
                <div className="new-script-form_predefined-scripts_body">
                    {hidePredefinedScripts ? <></> : <>
                        {!predefinedScripts ?
                            <Loader theme="dark" size="big" center={true} /> :
                            predefinedScripts.map(({ name, title, description }) => {
                                const isSelected = !!_.find(selectedPredefinedScripts, { initialTitle: title });
                                return <PredefinedScriptItem
                                    key={name}
                                    name={name}
                                    title={title}
                                    description={description}
                                    isSelected={isSelected}
                                    toggleScriptTemplate={this.togglePredefinedScript}
                                />;
                            })}</>}
                    <div className="new-script-form_add-script-mobile-form">
                        {selectedPredefinedScripts?.length === 0 ? newScriptForm : <></>}</div>
                </div>
                {selectedPredefinedScripts.length > 0 && predefinedScriptBtns}
            </div>
        </div>;

        return (
            <PopupWrapper className={`new-script-form ${hidePredefinedScripts && 'new-script-only'}`}>
                {device.isDesktop() ? desktopContent : mobileContent}
            </PopupWrapper>
        );
    }
}

function mapStateToProps({ predefinedScripts }) {
    return {
        predefinedScripts,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getPredefinedScripts: (param) => dispatch(actions.getPredefinedScripts(param)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withClickOutsideOnOverlay(NewScriptForm));